import React, {Component} from "react";
import {connect} from "react-redux";
import {graphql} from "react-apollo";
import {fromJS, List} from "immutable";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import ActionButton from "../../../components/ActionButton";
import {GET_STOCK_TRANSFER, ON_STOCK_TRANSFER_UPDATED} from "../../../queries/stockTransfers";
import SerialNumbersButton from "../../serialNumbers/SerialNumbersButton";
import {WarehousePlace, TransportPlace} from "../../shared/Places";
import {
  requestRemovePalletFromTransfer,
} from "../../../actions/StockTransferApiActions";
import "./StockTransferDetails.scss";

class StockTransferDetails extends Component {

  componentDidMount() {
    if (this.props.transferId && !this.unsubscribe) {
      this.subscribe();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.transferId && (prevProps.transferId !== this.props.transferId)) {
      this.subscribe();
    }
  }

  subscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToUpdates(this.props, {});
  }

  render() {
    let {loading, error, stockTransfer} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    if (!stockTransfer) return <p>Transfer not found</p>

    const transfer = fromJS(stockTransfer);
    const status = transfer.get("status");
    const isEditable = !!transfer.get("editable");
    const lines = transfer.get("lines", List());

    return (
      <div className="StockTransferDetails">
        <div className="overview section">
          <WarehousePlace title="Ship from" warehouseId={transfer.get("originWarehouseId")} />
          <WarehousePlace title="Ship to" warehouseId={transfer.get("destinationWarehouseId")} />
          <TransportPlace
            transportType={transfer.get("transportType")}
            carrierReference={transfer.get("carrierReference")}
            expectedDate={transfer.get("expectedArrivalDate")}
            expectedLabel={status === "received" ? "Was expected" : "Expected"} />
        </div>
        <div className="section">
          <h4>Pallets &amp; Lines</h4>
          {this.renderLines(lines, isEditable)}
        </div>
      </div>
    )
  }

  renderLines(lines, isEditable) {
    if (lines.size === 0) {
      return <p className="empty">No pallets have been added yet.</p>
    }

    // Group lines by pallet so a whole pallet can be removed together while editable.
    const byPallet = lines.groupBy((line) => line.get("palletId"));

    return byPallet.entrySeq().toArray().map(([palletId, palletLines]) => {
      const kind = palletLines.getIn([0, "kind"]);
      return (
        <div className="palletGroup" key={palletId}>
          <div className="palletHeader">
            <span className="palletId">Pallet {palletId}</span>
            <span className="palletMeta">{kind}</span>
            {isEditable &&
              <ActionButton label="Remove" primary={false}
                onClick={() => this.props.requestRemovePalletFromTransfer(this.props.transferId, palletId)} />}
          </div>
          <table className="linesTable">
            <thead>
              <tr>
                <th>SKU</th>
                <th>Manifest SKU</th>
                <th>Qty</th>
                <th>Received</th>
                <th>Serials</th>
              </tr>
            </thead>
            <tbody>
              {palletLines.map((line, i) => (
                <tr key={line.get("id", i)}>
                  <td>{line.get("stockSku")}</td>
                  <td>{line.get("sku")}</td>
                  <td>{line.get("quantity")}</td>
                  <td>{line.get("receivedQuantity")}</td>
                  <td><SerialNumbersButton serialNrs={line.get("serialNrs")} title={`Pallet ${palletId} · ${line.get("sku")}`} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
    })
  }
}

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_STOCK_TRANSFER_UPDATED,
      updateQuery: (prev, {subscriptionData}) => {
        props.data.refetch();
        return prev;
      }
    })
  },
  requestRemovePalletFromTransfer: (id, palletId) => dispatch(requestRemovePalletFromTransfer(id, palletId)),
})

const withQuery = graphql(GET_STOCK_TRANSFER, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      id: props.transferId
    },
    skip: !props.transferId,
  })
})

export default withQuery(connect(null, mapDispatchToProps)(StockTransferDetails));
